import { defineStore } from "pinia";

export default defineStore("ct:countryData", () => {
  const { $api } = useNuxtApp() as { $api: IApiInstance };
  const { notify } = useNotification();
  const { t } = useI18n();
  const config = useRuntimeConfig();

  const countryChoices = ref<CountryChoicesDataResponse[]>([]);
  const singleCountryData = ref<CountryChoicesDataResponse>({
    id: "",
    identifier: "",
    short_name: "",
    region_language: "",
    iso_code: "",
    iso_identifier: ""
  });

  const singleCountry = computed(() => {
    return singleCountryData;
  });

  const countriesLoading = ref<boolean>(false);

  async function loadCountryChoicesData () {
    countriesLoading.value = true;
    const { data, error } = await $api.user.countryChoicesData();
    if (error.value) {
      notify({
        title: t("form.common.error"),
        text: error.value!.data?.detail ?? t("general.error_sending_request"),
        type: "error"
      });
    }
    if (data?.value?.length) {
      countryChoices.value = data.value;
    }
    countriesLoading.value = false;
  }

  async function loadSingleCountryData (identifier: string) {
    const { data, error } = await $api.user.singleCountryData(identifier);
    if (error.value) {
      notify({
        title: t("form.common.error"),
        text: error.value!.data?.detail ?? t("general.error_sending_request"),
        type: "error"
      });
    }

    if (data.value) {
      singleCountryData.value = data.value;
    }
  }

  let countries: Country[] = [
    {
      name: "Česká republika",
      iso2: "CZ",
      dialCode: "420",
      priority: 0,
      areaCodes: null
    },
    {
      name: "Slovensko",
      iso2: "SK",
      dialCode: "421",
      priority: 1,
      areaCodes: null
    },
    {
      name: "Ukraine",
      iso2: "UA",
      dialCode: "380",
      priority: 2,
      areaCodes: null
    },
    {
      name: "Polska",
      iso2: "PL",
      dialCode: "48",
      priority: 3,
      areaCodes: null
    },
    {
      name: "Deutschland",
      iso2: "DE",
      dialCode: "49",
      priority: 4,
      areaCodes: null
    },
    {
      name: "Österreich",
      iso2: "AT",
      dialCode: "43",
      priority: 5,
      areaCodes: null
    }
  ];

  const currentRegionIso2 = config.public.region.toUpperCase();

  countries = countries.sort((a, b) => (a.iso2 === currentRegionIso2 ? -1 : b.iso2 === currentRegionIso2 ? 1 : 0));

  return {
    countryChoices,
    countriesLoading,
    loadCountryChoicesData,
    countries,
    loadSingleCountryData,
    singleCountry
  };
});
